var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120 60C120 93.1371 93.1371 120 60 120C26.8629 120 0 93.1371 0 60C0 26.8629 26.8629 0 60 0C93.1371 0 120 26.8629 120 60ZM62.1501 44.2947C56.3142 46.722 44.6506 51.746 27.1594 59.3666C24.3191 60.4961 22.8312 61.6011 22.6958 62.6815C22.4669 64.5075 24.7535 65.2265 27.8673 66.2057C28.2909 66.3388 28.7297 66.4768 29.1796 66.6231C32.2431 67.6189 36.3641 68.7839 38.5064 68.8302C40.4496 68.8722 42.6186 68.071 45.0132 66.4267C61.3557 55.395 69.7918 49.8191 70.3215 49.6989C70.6951 49.6141 71.213 49.5074 71.5638 49.8192C71.9146 50.1311 71.8801 50.7216 71.843 50.88C71.6164 51.8457 62.6406 60.1905 57.9955 64.5089C56.5475 65.8552 55.5203 66.8101 55.3103 67.0282C54.84 67.5168 54.3606 67.9789 53.8998 68.4231C51.0538 71.1667 48.9195 73.2242 54.018 76.584C56.4681 78.1986 58.4286 79.5337 60.3846 80.8657C62.5207 82.3204 64.6513 83.7713 67.408 85.5784C68.1103 86.0387 68.781 86.5169 69.4343 86.9827C71.9203 88.7549 74.1537 90.3471 76.9129 90.0932C78.5161 89.9457 80.1722 88.4381 81.0133 83.9418C83.001 73.3158 86.9081 50.2923 87.811 40.8049C87.8901 39.9737 87.7906 38.9099 87.7107 38.4429C87.6308 37.9759 87.4638 37.3105 86.8568 36.818C86.1379 36.2347 85.0281 36.1117 84.5318 36.1204C82.2751 36.1602 78.8127 37.3641 62.1501 44.2947Z",
    fill: "url(#paint0_linear_6_4)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_4",
    x1: 60,
    y1: 0,
    x2: 60,
    y2: 119.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.ab71bb97e3d1c8e7e142a9d34d7e797e.svg";
export { ForwardRef as ReactComponent };